export function setCheckoutAgreements(state, checkoutAgreements) {
  return {
    ...state,
    checkoutAgreements,
  };
}
